<template>
  <div :class="$style.sectionRoot">
    <header
      :class="[$style.header]"
      :style="headerMarginStyle"
    >
      <div
        :class="$style.collapsibleWrapper"
        @click="$emit('click')"
      >
        <div :class="$style.collapsibleLabel">
          <IconButton
            hasNoBackground
            icon="chevronDown"
            :iconClasses="{
              [$style.icon]: true,
              [$style.iconExpanded]: expanded,
            }"
            iconPosition="left"
            :isDisabled="disableCollapse"
            :scale="0.75"
            :text="sectionTitle"
          />
        </div>
      </div>

      <ButtonGroup
        :class="$style.headerButtons"
        :isFullWidth="false"
      >
        <slot name="buttons" />
      </ButtonGroup>
    </header>
    <TransitionWrapper name="slideVertical">
      <slot v-if="expanded" />
    </TransitionWrapper>
  </div>
</template>

<script>
import {
  ButtonGroup,
  IconButton,
  TransitionWrapper,
} from '@jumpcloud/ui-components';

export default {
  name: 'ApplicationCollapsibleSection',

  components: {
    ButtonGroup,
    IconButton,
    TransitionWrapper,
  },

  props: {
    disableCollapse: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: false,
    },

    sectionTitle: {
      type: String,
      required: true,
    },
  },

  computed: {
    headerMarginStyle() {
      return {
        marginBottom: `${this.expanded ? 1 : 0}rem`,
      };
    },
  },
};
</script>

<style module>
@import '../css/sections.css';
@import '../css/brand-colors.css';

.collapsibleLabel {
  --button-font-size: var(--collapsible-card-header-font-size, var(--jcHeadingSmall));
  --icon-button-spacing: var(--jc-spacer);
}

.collapsibleWrapper,
.header {
  align-items: center;
  column-gap: 1rem;
  cursor: pointer;
  display: flex;
}

.headerButtons {
  margin-left: auto;
}

.icon {
  transition: transform var(--jc-transition-duration) var(--jc-transition-function);
}

.iconExpanded {
  transform: rotate(180deg);
}
</style>
